import { Grid, Typography } from '@mui/material';
import { WorkOrderBid as WorkOrderBidType } from 'vendor-marketplace-shared-library';
import { WorkOrderBid } from '../../../components/work-orders/WorkOrderBid';

type WorkOrderBidsModuleProps = {
  workOrderBids: WorkOrderBidType[];
};
export default function WorkOrderBidsModule(props: WorkOrderBidsModuleProps) {
  return (
    <Grid container direction={'column'}>
      <Typography variant={'h6'}>Bids</Typography>
      <Grid
        item
        sx={{ backgroundColor: 'secondary.light' }}
        p={2}
        borderRadius={2}
        boxShadow={2}
        minHeight={150}
      >
        <Grid item container direction={'row'} spacing={2}>
          {props.workOrderBids.map(bid => (
            <Grid item key={bid.id}>
              <WorkOrderBid workOrderBid={bid} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
